import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Row, Col, Tab, Nav } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import break_box from '../../../../images/product/products.png';
// import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import AddPackage from './../../../modal/Package_Management/Manage_Package/AddPackage';
import EditPackage from './../../../modal/Package_Management/Manage_Package/EditPackage';
import ViewPackage from './../../../modal/Package_Management/Manage_Package/ViewPackage';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import AddPackagePeriod from './../../../modal/Package_Management/Manage_Package/AddPackagePeriod';
import EditPackagePeriod from './../../../modal/Package_Management/Manage_Package/EditPackagePeriod';
import axios from 'axios'; // new
import { toast } from 'react-toastify';

const Packages = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [packages, setPackage] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchPackage();
    }

    const handleProductStatusChange = (productId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.post(`${baseURL}/manage-package/status/${productId}`, { status: newStatus })
            .then(() => {
                // Re-fetch products after status update
                fetchPackage();
            })
            .catch(error => {
                console.error("Error updating product status:", error);
            });
    };

    const [settingToggle, setSettingToggle] = useState(false);
    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [key, setKey] = useState('products');
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const handleModalToggle = () => {
        setModalType("AddPackage");
        setOpen(true);
    };

    const [showModal, setShowModal] = useState(false);
    const [packageData, setPackageData] = useState(null);

    // Handle opening and closing the modal
    const handleModalToggle_View = (packageId) => {
        setShowModal(true);
        fetchPackageDetails(packageId);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const fetchPackageDetails = (id) => {
        console.log('Package ID:', id); // Debugging line
        axios.get(`${baseURL}/manage-package/${id}`)
            .then(response => {
                setPackageData(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching package details', error);
            });
    };

    const [selectedItem, setSelectedItem] = useState(null);

    const handleModalToggle_Edit = (item) => {
        axios.get(`${baseURL}/manage-package/${item.sno}`)
            .then(response => {
                setSelectedItem(response.data.data); // send full item details to modal
                setModalType("EditPackage");
                setOpen(true);
            })
            .catch(error => {
                console.error("Failed to fetch package for edit:", error);
            });
    };

    const DeleteModal = (packageId, packageName, onDeleted) => {
        swal.fire({
            html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose one Products
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <p class="text-center"><b>${packageName}</b></p>  
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                <defs>
                                    <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#5987dd"/>
                                        <stop offset=".118" stop-color="#638bd6"/>
                                        <stop offset=".316" stop-color="#7d98c3"/>
                                        <stop offset=".572" stop-color="#a8aba3"/>
                                        <stop offset=".871" stop-color="#e3c678"/>
                                        <stop offset="1" stop-color="#ffd364"/>
                                    </radialGradient>
                                    <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                                </defs>
                                <g id="_27-feel_bad" data-name="27-feel bad">
                                    <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                    <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                    <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                    <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="34" cy="22" r="1"/>
                                    <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="16" cy="22" r="1"/>
                                    <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                    <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                    <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                    <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                    <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                    <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                    <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                    <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                    <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                    <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                    <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                                </g>
                            </svg>
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/manage-package/${packageId}`) // change 
                    .then(() => {
                        toast.success(`${packageName} has been deleted.`, {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        //  if (onDeleted) onDeleted(); // Refresh the list or update UI // change 

                        // Refresh categories list or do a soft reload
                        if (typeof fetchPackage === 'function') {
                            fetchPackage();
                        } else {
                            softRefresh(); // your fallback
                        }
                    })
                    .catch((error) => {
                        console.error("Delete failed:", error);
                        toast.error("Something went wrong while deleting.", {
                            position: "top-center",
                            autoClose: 4000,
                            theme: "colored",
                        });
                    });
            } else {
                toast.info(`Deletion cancelled. ${packageName}was not deleted.`, {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        });
    };

    const [timelineCount, setTimelineCount] = useState(0); //package timelinescount
    const [managePackageCount, setManagePackageCount] = useState(0);  // package count

    useEffect(() => {
        const storedBranchId = localStorage.getItem("branch_id"); // define it here
        const branch_id = storedBranchId && !isNaN(parseInt(storedBranchId, 10))
            ? parseInt(storedBranchId, 10)
            : null;

        if (!branch_id) {
            console.warn("Invalid branch_id:", storedBranchId);
            setPackage([]);
            setManagePackageCount(0);
            return;
        }

        axios.get(`${baseURL}/manage-package`, {
            params: { branch_id }
        })
            .then(response => {
                const data = response.data;

                if (Array.isArray(data)) {
                    setPackage(data);
                    setManagePackageCount(data.ManagePackageCount || 0);
                } else if (Array.isArray(data?.data)) {
                    setPackage(data.data);
                    setManagePackageCount(data.ManagePackageCount || 0);
                } else {
                    console.warn("Unexpected response format for products:", data);
                    setPackage([]);
                    setManagePackageCount(data?.ManagePackageCount || 0);
                }
            })
            .catch(error => {
                console.error("Error fetching products:", error);
                setPackage([]);
                setManagePackageCount(0);
            });
    }, []); // no dependency needed if storedBranchId comes from localStorage

    // ✅ Declare all states first
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    const fetchPackage = async (pageNumber = 1, perPageCount = 25, search = '') => {
        try {

            const response = await axios.get(`${baseURL}/manage-package`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                    branch_id
                }
            });

            const data = response.data;

            if (Array.isArray(data.data)) {
                setPackage(data.data);
                setManagePackageCount(data.ManagePackageCount || data.data.length);
            } else if (Array.isArray(data)) {
                setPackage(data);
                setManagePackageCount(data.ManagePackageCount || data.length);
            } else {
                console.warn("Unexpected response format:", data);
                setPackage([]);
                setManagePackageCount(0);
            }
        } catch (error) {
            console.error("Error fetching packages:", error);
            setPackage([]);
            setManagePackageCount(0);
        }
    };

    // useEffect to run on mount and whenever pagination/search changes
    useEffect(() => {
        if (branch_id) {
            fetchPackage(page, perPage, searchTerm);
        }
    }, [page, perPage, searchTerm, branch_id]);

    // use for package timeline count
    useEffect(() => {
        const branchId = localStorage.getItem("branch_id"); // get branch_id from localStorage

        axios.get(`${baseURL}/package-timeline`, {
            // params: branchId ? { branch_id: branchId } : {} // include branch_id if exists
        })
            .then(response => {
                const data = response.data;
                if (data?.PackageTimelineCount) {
                    setTimelineCount(data.PackageTimelineCount);  // Set the count value
                } else {
                    console.warn("Unexpected response format:", data);
                    setTimelineCount(0);  // Default if count is not found
                }
            })
            .catch(error => {
                console.error("Error fetching package timeline count:", error);
                setTimelineCount(0);  // Default if error occurs
            });
    }, []);


    useEffect(() => {

        if (packages.length > 0 && tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    responsive: true,
                    pageLength: 25,
                    ordering: false,
                    language: {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    dom:
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, [packages]);


    const handleAddSuccess = () => {
        console.log("Add success called!");
        toast.success("Package added successfully!");
        setOpen(false);
        softRefresh();
    };

    const [isMaintenance, setIsMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "manage-packages"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (loading) {
        return <div>Loading...</div>; // optional loading state
    }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Packages</strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Packages</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Package Management</li>
                    </ol>
                </div>

                {open && modalType === "AddPackage" && (
                    <AddPackage show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}
                {open && modalType === "ViewPackage" && (
                    <ViewPackage show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "AddPackagePeriod" && (
                    <AddPackagePeriod show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "EditPackagePeriod" && (
                    <EditPackagePeriod show={open} onClose={() => setOpen(false)} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="products">
                                    <Link to="/manage-packages" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-boxes-packing me-3" />
                                        <label className="fs-6">
                                            Packages
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                            {String(managePackageCount).padStart(2, '0')}  {/* Display the dynamic count */}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/package-period" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-timeline me-3" />
                                        <label className="fs-6">
                                            Timeline
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                            {String(timelineCount).padStart(2, '0')}  {/* Display the dynamic count */}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className="pt-4">

                            <Tab.Pane eventKey="products">
                                <Row>
                                    <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>
                                        <Link to={"#"} className="btn btn-primary float-end btn-sm mb-2" onClick={handleModalToggle}>
                                            <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                                            <span className='fs-7'>Add Package</span>
                                        </Link>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="table-container">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/* Left: Show entries dropdown */}
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1); // Reset to first page
                                                        }}
                                                    >
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                        <option value={125}>125</option>
                                                    </select>
                                                </div>

                                                {/* Right: Search input */}
                                                <div>
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px', width: '100%' }}
                                                        placeholder="Search by package/product/product category/timeline..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                                            setSearchTerm(onlyLetters);
                                                            setPage(1);
                                                        }}

                                                    />
                                                </div>
                                            </div>

                                            <table className="package_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                <thead>
                                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px'>Package</th>
                                                        <th className='min-w-125px'>Products</th>
                                                        <th className='min-w-100px'>Timeline</th>
                                                        <th className='min-w-100px'>Oneday Selling Amount</th>
                                                        <th className='min-w-100px'>Selling Amount</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-80px'>Actions</th>
                                                    </tr>
                                                </thead>

                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {Array.isArray(packages) && packages.length > 0 ? (
                                                        packages.map((item, index) => (
                                                            <tr key={item.sno || index}>
                                                                <td>
                                                                    <label className='text-black font-w400 fs-7 text-wrap mw-200px'>
                                                                        {item.package_name}
                                                                    </label>
                                                                </td>

                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                            <div data-src={item.product_image || break_box} className='border rounded px-1 py-0'>
                                                                                <img src={item.product_image || break_box} alt="Break Box" className='cursor-pointer w-45px h-45px' />
                                                                            </div>
                                                                        </LightGallery>
                                                                        <div>
                                                                            <label className='text-black font-w400 fs-7'>{item.product_name}</label>
                                                                            <div className="d-block">
                                                                                <label className="fs-8 text-dark font-w600">{item.product_category_name}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <label className='text-black font-w400 fs-7'>
                                                                        {item.timeline_details?.packagetimeline_name || 'N/A'}
                                                                        {item.timeline_details?.days ? ` (${item.timeline_details.days} Days)` : ' No Days'}
                                                                    </label>
                                                                    <div className="d-block">
                                                                        <label className="fs-8 text-dark font-w600">
                                                                            {item.timeline_details?.all_days === 0
                                                                                ? ' (All Days)'
                                                                                : (() => {
                                                                                    const daysOfWeek = [
                                                                                        { key: 'sunday', label: 'Sun' },
                                                                                        { key: 'monday', label: 'Mon' },
                                                                                        { key: 'tuesday', label: 'Tue' },
                                                                                        { key: 'wednesday', label: 'Wed' },
                                                                                        { key: 'thursday', label: 'Thu' },
                                                                                        { key: 'friday', label: 'Fri' },
                                                                                        { key: 'saturday', label: 'Sat' },
                                                                                    ];
                                                                                    const selectedDays = daysOfWeek
                                                                                        .filter(day => item.timeline_details?.[day.key] === '0')
                                                                                        .map(day => day.label);
                                                                                    return selectedDays.length > 0 ? ` (${selectedDays.join(', ')})` : ' 0 details';
                                                                                })()
                                                                            }
                                                                        </label>
                                                                    </div>
                                                                </td>

                                                                <td className='text-end'>
                                                                    <label className='text-green font-w600 fs-7'>
                                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                                        {new Intl.NumberFormat('en-IN').format(item.product_amount)}
                                                                    </label>
                                                                </td>

                                                                <td className='text-end'>
                                                                    <label className='text-green font-w600 fs-7'>
                                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                                        {new Intl.NumberFormat('en-IN').format(item.selling_amount)}
                                                                    </label>
                                                                </td>

                                                                <td>
                                                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                        <input
                                                                            className="form-check-input me-2"
                                                                            type="checkbox"
                                                                            role="switch"
                                                                            checked={item.status == 0}
                                                                            onChange={() => handleProductStatusChange(item.sno, item.status)}
                                                                        />
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <span className="text-end">
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>}
                                                                        >
                                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_View(item.sno)}>
                                                                                <i className="fa-solid fa-eye fs-6 mt-1"></i>
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>}
                                                                        >
                                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(item)}>
                                                                                <i className="fa-solid fa-pen-to-square fs-6 mt-1"></i>
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center py-4 text-muted">
                                                                <i className="fa fa-box-open me-2"></i> No packages found.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>

                                            </table>


                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* Bottom left: Showing x to y of z entries */}
                                                <div>
                                                    {packages.length > 0 && (
                                                        <span className="text-muted">
                                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + packages.length} of {totalPages * perPage - (perPage - packages.length)} entries
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Bottom right: Pagination */}
                                                <nav>
                                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                        </li>
                                                        {[...Array(totalPages)].map((_, i) => (
                                                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>

                                            </div>


                                            {showModal && packageData && (
                                                <ViewPackage
                                                    show={showModal}
                                                    onClose={handleCloseModal}
                                                    data={packageData}
                                                />
                                            )}

                                            {open && modalType === "EditPackage" && (
                                                <EditPackage
                                                    show={open}
                                                    onClose={() => setOpen(false)}
                                                    packageData={selectedItem}
                                                    refresh={fetchPackage}
                                                />
                                            )}


                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default Packages;